/**
 * get social network feed
 * 	- twitter part based on #### Twitter Post Fetcher v5.0 #### by Jason Mayes
 */

require(['jquery'], function($){

	"use strict";

	var PLUGIN_NAME = "socialNetworkFetcher";
	var PLUGIN_VERSION = "v2.0";

	var	DEFAULTS = {
		twitterId:			"",
		postsCount:			5,
		removeUrls:			false,
		dateFormatPattern:	'd of MMMMM, yyyy',
		lang:				'en',
		messages:			{
			'en' : {
				monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
				monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
				more: 'View on Twitter'
			},
			'cs' : {
				monthNames: ['Leden', 'Únor', 'Březen', 'Duben', 'Květen', 'Červen', 'Červenec', 'Srpen', 'Září', 'Říjen', 'Listopad', 'Prosinec'],
				monthNamesShort: ['Led', 'Úno', 'Bře', 'Dub', 'Kvě', 'Čer', 'Čec', 'Srp', 'Zář', 'Říj', 'Lis', 'Pro'],
				more: 'Celý tweet'
			}
		},
		twitterTemplate: function(data, o) {
			var str = '<div class="row">';
			$.each(data, function(index, item) {
				str += '<div class="item col-xxs-8 col-xxs-offset-2 col-md-11 col-md-offset-1 item-twitter">';
				if (item.retweetcredit && item.retweetcredit.name && item.retweetcredit.name != '') {
					str += '<p class="twitter-tweet-info">' + item.retweetcredit.name + '<time class="tweet-date">'+item.pubdateFormatted+'</time>';
					if (item.user.img) { str += '<img src="' + item.user.img + '" class="twitter-user-ico"></p>'; }
				}
				else if (item.user) {
					if (item.user.name) {
						str += '<p class="twitter-tweet-info"><a href="'+item.user.url+'" target="_blank">';
						if (item.user.img) { str += '<img src="' + item.user.img + '" class="twitter-user-ico">'; }
						str += item.user.name +' <small>'+item.user.nickname+'</small></a><time class="tweet-date">'+item.pubdateFormatted+'</time></p>' }
				}
				str += '<p>' + item.tweetcontent + '</p>';
				if (item.permalink) {
					str += '<p class="twitter-more"><a href="'+item.permalink+'" target="_blank">'+ o.messages[o.lang].more + '</a>';
				}
				str += '</div>';
			});
			str += '</div>';
			return str;
		}
	};

	/**
	 *
	 * @param element
	 * @param options
	 * @constructor
	 */
	var SocialNetworkFetcher = function ( element, options ) {
		this.element = element;
		this.$t = $(this.element);

		this.options = $.extend(true, {}, DEFAULTS, options );
		this._defaults = DEFAULTS;

		this.$infiniteNextWrapper = null;
		this.$wrapper = null;

		this.debugEnabled_ = false;

		this.initialise_();
	};

	SocialNetworkFetcher.prototype.formatDate_ = function(dt, pattern, messages) {
		var result = pattern;
		var fd = dt.getDate();
		if (fd < 10) fd = "0"+fd;
		var fm = dt.getMonth()+1;
		if (fm < 10) fm = "0"+fm;

		var fms = messages.monthNames[dt.getMonth()];
		var fmss = messages.monthNamesShort[dt.getMonth()];

		var fs = dt.getSeconds();
		if (fs < 10) fs = "0"+fs;

		result = result.replace(/dd/gi, fd);
		result = result.replace(/d/gi, dt.getDate());
		if (pattern.indexOf('MM') < 0) {
			result = result.replace(/M/gi, dt.getMonth()+1);
		}
		result = result.replace(/MMMMM/gi, fms);
		result = result.replace(/MMM/gi, fmss);
		result = result.replace(/MM/gi, fm);
		result = result.replace(/yyyy/gi, dt.getFullYear());
		result = result.replace(/HH/gi, dt.getHours());
		result = result.replace(/mm/gi, dt.getMinutes());
		result = result.replace(/ss/gi, fs);
		return result;
	};

	/**
	 * Init function - read options.cookieName status,
	 * @private
	 */
	SocialNetworkFetcher.prototype.initialise_ = function() {
		if (this.options.twitterId != "") {
			this.getDataFromTwitter_();
		}
	};

	SocialNetworkFetcher.prototype.getDataFromTwitter_ = function() {
		var self_ = this;
		var dataUrl = 'https://cdn.syndication.twimg.com/widgets/timelines/' + this.options.twitterId + '?&lang=' + this.options.lang + '&suppress_response_codes=true&rnd=' + new Date().getTime() + '&callback=?';
		$.getJSON(dataUrl, function(dt) {
			if (dt.headers.status == 200 && dt.body) {
				self_.parseTwitterData_(dt.body);
			}
		});
	};

	SocialNetworkFetcher.prototype.parseTwitterData_ = function(data) {
		var $streamBody = $(data);
		var item;
		var result = [];

		var self_ = this;

		$('.timeline-Tweet:lt('+this.options.postsCount+')', $streamBody).each(function(index, tweet) {
			item = {};
			// display user info
			var $userA = $(tweet).find('.timeline-Tweet-author');
			item.user = {};
			item.user.url = $('.TweetAuthor-link', $userA).attr('href');
			item.user.img = $('.TweetAuthor-avatar img', $userA).attr('data-src-2x');
			item.user.name = $('.TweetAuthor-name', $userA).text();
			item.user.nickname = $('.TweetAuthor-screenName', $userA).text();

			// get permalink
			item.permalink = $(tweet).find('a.timeline-Tweet-timestamp').attr('href');

			// display tweet itself
			var tweetContent = $(tweet).find('.timeline-Tweet-text').html();
			if (self_.options.removeUrls) {
				tweetContent = tweetContent.replace(/<a.*?>/gi, "");
			}
			tweetContent = tweetContent.replace(/ class=".*?"| dir=".*?"| data-query-source=".*?"| rel=".*?"| data-scribe=".*?"| data-mentioned-user-id=".*?"| data-expanded-url=".*?"| data-pre-embedded=".*?"/gi, "");
			tweetContent = tweetContent.replace(/href="/gi, "target=\"_blank\" href=\"");
			item.tweetcontent = tweetContent;

			item.tweetmedia = {};

			// inline image
			if ($(tweet).find('.timeline-Tweet-media .MediaCard-mediaContainer a img').size() > 0) {
				item.tweetmedia.image = {};

				var thumbsset = decodeURIComponent(String($(tweet).find('.timeline-Tweet-media .MediaCard-mediaContainer a img:first').attr('data-srcset')));
				var thumb, imageSize;

				if (!thumbsset || thumbsset ==  '') {
					return false;
				}

				var thumblist = thumbsset.split(',');

				for (var i = 0; i < thumblist.length; i++) {
					thumb = thumblist[i];

					if (window.location.protocol ==  'http:') {
						thumb = thumb.replace('https://','http://');
					} else {
						thumb = thumb.replace('http://','https://');
					}

					thumb = thumb.substring(0, thumb.indexOf(' '));

					imageSize = (thumb.lastIndexOf(':') > 10) ? thumb.substring(thumb.lastIndexOf(':') + 1) : 'default';

					item.tweetmedia.image[imageSize] = thumb;
				}

				item.tweetmedia.image.url =  $(tweet).find('.timeline-Tweet-media .MediaCard-mediaContainer a:first').attr('href');
			}

			// retweeted by
			if ($(tweet).find('.timeline-Tweet-retweetCredit').size() > 0) {
				item.retweetcredit = {};
				item.retweetcredit.name = $.trim($(tweet).find('.timeline-Tweet-retweetCredit').text());
			}

			// show and format date
			var dtString = $(tweet).find('.timeline-Tweet-metadata .dt-updated').attr('datetime');
			dtString = dtString.substring(0, dtString.indexOf('+'));
			var pubDate = new Date();
			if (navigator.userAgent.indexOf ('MSIE 8.0') > -1 || navigator.userAgent.indexOf ('MSIE 7.0') > -1  || navigator.userAgent.indexOf ('Safari') > -1) {
				pubDate = new Date(dtString.substr(0, 4), parseInt(dtString.substr(5, 2))-1, dtString.substr(8, 2), dtString.substr(11, 2), dtString.substr(14, 2), dtString.substr(17, 2));
			} else {
				pubDate = new Date(dtString);
			}

			item.pubdate = pubDate;
			item.pubdateFormatted = self_.formatDate_(pubDate, self_.options.dateFormatPattern, self_.options.messages[self_.options.lang]);

			item.twTools = {};
			item.twTools.retweet = $(tweet).find('.timeline-ShareMenu-container .timeline-ShareMenu-option[data="element:twitter"]').attr('href');
			result.push(item);

		});

		//console.log(result);
		this.$t.append(this.options.twitterTemplate(result, this.options));
	};

	var API = {
	};

	/**
	 * plugin go live
	 * @param value - first param - decides, which action shall be executed
	 * 		if object - apply plugin with these settings to an selector's elements, if they are clean (plugin not applied yet)
	 * 		if string && in API object - run method named as this value with all args[index > 0]
	 * @return {*}
	 */
	$.fn[PLUGIN_NAME] = function (value) {
		var args = arguments;

		return this.each(function () {
			var $this = $(this);

			// get plugin instance
			var plugin = $this.data('plugin_' + PLUGIN_NAME);

			// if there's not, create one
			if (!plugin) {
				plugin = new SocialNetworkFetcher(this, value);
				$this.data('plugin_' + PLUGIN_NAME, plugin);
			}
			// if there is and first parameter is in predefined API methods, call it with rest of params
			else if (API[value]) {
				plugin[value].apply(plugin, Array.prototype.slice.call(args, 1));
			}
		});
	};

	/**
	 * setDefaults with $.googlemap.setDefaults();
	 */
	$[PLUGIN_NAME] = $.fn[PLUGIN_NAME];
	$[PLUGIN_NAME].setDefaults = function(newOptions) {
		DEFAULTS = $.extend(true, {}, DEFAULTS, newOptions);
	};

});


// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/jquery.socialNetworkFetcher.js